module.exports = __webpack_public_path__ + "media/images/how_it_works/support-9a9a31bf6404e74eb435d15c44b8e8ca.svg";